/* eslint-disable */
<template>
  <div class="content-wrapper h-100 information-wrapper">
    <div class="block-title">{{ title }}</div>
    <template v-if="Object.keys(items).length">
      <div class="table-layout" :style="{ gridTemplateRows: `repeat(auto, 32px)` }">
        <template v-for="field in fields">
          <template>
            <div :key="`${field.key}_label`" class="field-label d-flex align-items-center">
              <div v-if="field.icon" class="mr-1 d-flex">
                <img v-if="notExistingsMaterialIcons.includes(field.icon)" :src="getFieldIcon(field)" alt="icon" />
                <span v-else class="material-symbols-outlined material-symbols-fill-1 icon-size">
                  {{ getFieldMaterialIcon(field) }}
                </span>
              </div>
              <span class="field-label-text">{{ field.label }}</span>
              <span v-if="field.info && isEditAllowed"
                v-b-tooltip.html.hover.bottom="{ variant: 'base', title: field.info, }"
                class="mx-1 mb-1 material-icons">
                info
              </span>
            </div>
            <a v-if="field.isLink && getFieldValue(field)" :key="`${field.key}_link`"
              :class="field.class"
              class="field-value field-value__link d-flex align-items-center" target="_blank"
              :href="getFieldValue(field)">Document</a>
            <template v-else-if="field.isEditable && isEditAllowed">
              <div v-if="activeEditField.key !== field.key" :key="`${field.key}_value`"
                :class="field.class"
                class="field-value d-flex align-items-center justify-content-between">
                <span>{{ getFieldValue(field) }}</span>
                <span @click="setActiveEditField({ key: field.key, value: items[field.key] })"
                  class="material-icons text-primary cursor-pointer">
                  edit
                </span>
              </div>
              <div v-else :key="`${field.key}_input`" class="d-flex align-items-center gap-10">
                <input type="text" class="form-control" v-model="items[field.key]" />
                <span
                  @click="() => { items[field.key] = activeEditField.value; setActiveEditField({ key: null, value: null }) }"
                  class="material-icons text-danger cursor-pointer">
                  close
                </span>
                <span @click="() => {
                  if (field.validation(items[field.key])) {
                    const oldValue = `${activeEditField.value}`;
                    field.sub(items[field.key], oldValue);
                    setActiveEditField({ key: null, value: null });
                  } else {
                    $snotify.error(`Invalid ${field.key} field value`, 'Error', $store.state.snotify)
                  }
                }" class="material-icons text-primary cursor-pointer">
                  check
                </span>
              </div>
            </template>

            <div v-else :key="`${field.key}_value`" :class="field.class" class="field-value d-flex align-items-center">
              <template v-if="getFieldValue(field)">
                <span class="field-value-text">{{ getFieldValue(field) }}</span>
              </template>
              <NoDataText v-else />
            </div>
          </template>

        </template>
      </div>
    </template>
  </div>
</template>

<script>
import emailIcon from '@/assets/email.svg'
import telegramIcon from '@/assets/ic_baseline-telegram.svg'
import documentIcon from '@/assets/ion_document.svg'
import calendarIcon from '@/assets/perm_contact_calendar.svg'
import phoneIcon from '@/assets/phone.svg'
import skypeIcon from '@/assets/ri_skype-fill.svg'
import NoDataText from '@components/common/NoDataText'

export default {
  name: 'ProfileInformationTable',
  components: { NoDataText },
  props: {
    items: {
      type: Object,
      default: () => ({ })
    },
    fields: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Information'
    },
    isEditAllowed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      emailIcon,
      telegramIcon,
      documentIcon,
      calendarIcon,
      phoneIcon,
      skypeIcon,
      notExistingsMaterialIcons: [
        'skype',
        'telegram'
      ],
      activeEditField: { key: null, value: null }
    }
  },
  methods: {
    setActiveEditField (field) {
      this.activeEditField = field
    },
    getFieldValue (field) {
      if (field.isArray) {
        return this.items[field.key] && this.items[field.key].reduce((acc, cur) => field.isObject ? !acc ? cur[field.isObject] : `${acc}, ${cur[field.isObject]}` : !acc ? cur : `${acc}, ${cur}`, '')
      } else if (field.isObject) {
        return this.items[field.key]?.[field.isObject]
      } else {
        return this.items[field.key]
      }
    },
    getFieldMaterialIcon (field) {
      switch (field.icon) {
        case 'document':
          return 'draft'
        case 'email':
          return 'mail'
        case 'phone':
          return 'phone'
        case 'calendar':
          return 'perm_contact_calendar'
        default:
          return null
      }
    },
    getFieldIcon (field) {
      switch (field.icon) {
        case 'skype':
          return this.skypeIcon
        case 'telegram':
          return this.telegramIcon
        default:
          return null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.field-label {
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
}

.field-label-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.field-value {
  font-size: 13px;
  line-height: 24px;
  font-weight: 400;
  min-width: 0;

  &__link {
    color: $fontColorAccent;
    font-weight: 500;
    text-decoration: none;
  }
}

.field-value-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
}

.content-wrapper {
  background-color: #ffffff;
  border-radius: 10px;
}

.information-wrapper {
  padding: 20px;
}

.table-layout {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 10px;
  column-gap: 25px;
  margin-top: 10px;
}

.icon-size {
  font-size: 18px;
}

</style>
